//@ts-nocheck

import { AuthController } from "@api/AuthController";
import { useWallet } from "@stores/wallet.store";
import { CHAIN, useTonAddress, useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import { showToast } from "@utils/showToast";
import { useEffect, useState } from "react";

export const useConnectWallet = (setIsConnectWalletModalVisible: (value: boolean) => void) => {
    const setAuth = useWallet((state) => state.setAuth);
    const getWallets = useWallet((state) => state.getWallets);
    const fetchReferrals = useWallet((state) => state.fetchReferrals);
    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const address = useTonAddress(true);
    const [proof, setProof] = useState(null);
    useEffect(() => {
        if (!proof || !address) return;
        const doJob = async () => {
            const jwt = await AuthController.checkProof(proof.proof, {
                ...proof.account,
                friendlyAddress: address,
            });

            if (!jwt) {
                return;
            }

            setIsConnectWalletModalVisible(false);
            setAuth(true, jwt);

            await fetchReferrals();
            await getWallets();
        };

        doJob();
    }, [address, proof]);

    useEffect(() => {
        tonConnectUI.onStatusChange(async (w) => {
            if (!w || w.account.chain === CHAIN.TESTNET || !w?.connectItems?.tonProof?.proof) return;

            setProof({ proof: w.connectItems.tonProof.proof, account: w.account });
        });
    }, [tonConnectUI]);

    const auth = async () => {
        const payload = await AuthController.generatePayload();
        if (!payload) return;

        tonConnectUI.setConnectRequestParameters({
            state: "ready",
            value: payload,
        });
    };

    useEffect(() => {
        auth();
    }, [wallet]);
};
